
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from "react-redux";
import { editDeleteQuotation, getDocNoFormateAvailable, getInvoiceSettingList, getPrintSetupList, getQuotationList, getTermsConditionsList } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import AddIcon from '@mui/icons-material/Add';
import { dateConversion, dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'

import QuotationAdd from "./QuotationAdd";
import QuotationDetails from "./QuotationDetails";
import QuotationPrint from "./QuotationPrint";
import { NavLink, useNavigate } from "react-router-dom";
import { BackBtn } from "../../reusableComponent/BackBtn";
import SalesHome from "../salesHome/SalesHome";

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, printSetupDetails, invoiceSettingList } = props;
    return (
        <div className="print-source" ref={ref}>
            <QuotationPrint quotationPrint={value} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
        </div>
    );
});

const ComponentToPrintQuotationWrapper = ({ quotationPrint, printSetupDetails, invoiceSettingList }) => {
    const ref = useRef();

    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" />  <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={quotationPrint} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
            </div>
        </div>
    );
};
function QuotationList(props) {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);
    // const [open, setOpen] = React.useState(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [openOption, setOpenOption] = useState('');

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption(info.qt_id ? 'QTUpdate' : 'QTAdd')
    };
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }


    const [q, setQ] = useState("");
    const [searchParam] = useState(["CNS_Name", "CNS_Type", "city", "contactPerson", "creditLimit", "creditPeriod", "emailId", "enquiryNo", "enquiryDate", "quotationNo", "quotationDate", "validity", "remark", "basicTotal", "gstTotal", "total"]);

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();

    const rows = useSelector(state => state.quotation.quotation)
    const printSetupDetails = useSelector(state => state.printSetup.printSetup)
    const invoiceSettingList = useSelector(state => state.invoiceSetting.invoiceSetting)
    const docNoFormateAvailable = useSelector(state => state.docNoFormate.docNoFormateAvailable)
    const termsList = useSelector(state => state.termsConditions.termsConditions)
    const fetchData = () => {
        dispatch(getQuotationList({ companyId: userInfo.companyId }))
        dispatch(getPrintSetupList({ companyId: userInfo.companyId }))
        dispatch(getInvoiceSettingList({ companyId: userInfo.companyId }))
        dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Quotation' }))
        dispatch(getTermsConditionsList({ companyId: userInfo.companyId, terms: 'Quotation' }));
    };
    useEffect(() => {
        fetchData()
    }, []);
    useEffect(()=>{
    }, [termsList])
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.quotation.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);


    const deleteRecord = (qt_id) => {
        dispatch(editDeleteQuotation({ id: qt_id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        // setAnchorEl(null);
        setOpenPopup(false);
    };
    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('QTDetails')
    }
    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

    const [sortBy, setSortBy] = useState(null);
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows && rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else if (typeof a[property] === 'string' && typeof b[property] === 'string') {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            } else {
                return 0;
            }
        });
    };

    const fields = ['qt_id', "quotationNo", "quotationDate", "enquiryNo", "enquiryDate", "CNS_Name", "validity", "contactPerson", "remark", "basicTotal", "gstTotal", "total"];
    const labels = ['Id', "Quotation No", "Quotation Date", "Enquiry No", "Enquiry Date", "Customer Name", "Validity", "Contact Person", "Remark", "Basic Total", "GST Total", "Total"];

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };
    
    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const navigate = useNavigate()
    const backBtn = props.currentTab
    const navigateToAddEdit = (row) => {
        const state = {
            row,
            invoiceSettingList,
            docNoFormateAvailable,
            backBtn,
            termsList
        };
        navigate('/sales/add-quotaion', { state });
    };

  
    return (
        <>
          <Breadcrumb
                        routeSegments={[
                            { name: 'Sales', path: '/sales/' },
                            { name: 'Sales Quotaion List' },
                        ]}
                    />
        <SalesHome/>
            <Paper className={`${styles.list_container}`}>
             
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={0}>

                        </Grid>
                        <Grid item md={5} xs={12} style={{ display: 'flex', }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Sales Quotaion List"
                                />
                            </Box>

                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined className={`${styles.search_icon}`} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button variant="contained" className={`${styles.add_btn}`} onClick={() => navigateToAddEdit()}>
                                <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('QuotationNo')}>Quotation No <span className={`${styles.sort_icon}`}> {sortBy === 'QuotationNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('quotationDate')}>Quotation Date<span className={`${styles.sort_icon}`}> {sortBy === 'quotationDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('enquiryNo')}>Enquiry No<span className={`${styles.sort_icon}`}> {sortBy === 'enquiryNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('enquiryDate')}>Enquiry Date<span className={`${styles.sort_icon}`}> {sortBy === 'enquiryDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('CNS_Name')}>Customer Name<span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Name' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('validity')}><span className={`${styles.sort_icon}`}> {sortBy === 'validity' ? '▲' : '▼'} </span>Validity</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('basicTotal')}><span className={`${styles.sort_icon}`}> {sortBy === 'basicTotal' ? '▲' : '▼'} </span>Basic Total</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('gstTotal')}><span className={`${styles.sort_icon}`}> {sortBy === 'gstTotal' ? '▲' : '▼'} </span>GST Total</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('total')}><span className={`${styles.sort_icon}`}> {sortBy === 'total' ? '▲' : '▼'} </span>Total</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.qt_id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <StyledTableCell align="center" className='listTableBody'>
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            {...bindTrigger(popupState)}
                                                        />
                                                        <Popover
                                                          
                                                            {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >

                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => navigateToAddEdit(row)}>
                                                                        <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                        <span style={{ marginRight: '13px' }}> Edit Record</span>
                                                                    </Button>

                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={popupState.close}>
                                                                        <ComponentToPrintQuotationWrapper key={index} quotationPrint={row} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
                                                                    </Button> 
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close()}}>
                                                                        <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                    </Button>
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                            <span style={{ cursor: 'pointer', color: 'blue' }} > {row.quotationNo}</span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.quotationDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.enquiryNo}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.enquiryDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.customerName == null ? '-' : row.CNS_Name}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.validity}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.basicTotal).toFixed(2)}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.gstTotal).toFixed(2)}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.total).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2 }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.quotationNo}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.qt_id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        minWidth: "85%",
                        minHeight: "95%"
                    }
                }}
                onClose={handleClose}
                open={openPopup} >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'QTAdd' && 'Create Sales Quotation'}
                    {openOption === 'QTUpdate' && 'Update Sales Quotation'}
                    {openOption === 'QTDetails' && 'Sales Quotation Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {(openOption === 'QTUpdate' || openOption === 'QTAdd') &&
                        <QuotationAdd handleCloseDialog={handleClose} details={info} invoiceSettingList={invoiceSettingList} docNoFormateAvailable={docNoFormateAvailable} onAPISubmt={fetchData} />
                    }
                    {openOption === 'QTDetails' &&
                        <QuotationDetails details={info} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} termsList={termsList}/>
                    }
                </DialogContent>
            </BootstrapDialog>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>
    )
}
export default QuotationList